<rb-form-date-input
  name="date"
  [label]="'Date UTC'"
  [ngModel]="date"
  (ngModelChange)="onChange($event)"
  [options]="{
    allowInput: true,
    minDate: minDate,
    maxDate: maxDate,
    disableMobile: true,
    enableTime: false,
    dateFormat: 'd.m.Y',
  }"
  required
  [disabled]="disabled"
  data-cy="datetime-picker"
>
</rb-form-date-input>
